import React from 'react';
import admin, { Admin } from './modules/admin';
import agent, { Agent } from './modules/agent';
import auth, { Auth } from './modules/auth';
import contract, { Contract } from './modules/contract';
import supplier, { Supplier } from './modules/supplier';
export type RootStore = {
  auth: Auth;
  supplier: Supplier;
  contract: Contract;
  agent: Agent;
  admin: Admin;
};

export const store: RootStore = {
  auth,
  supplier,
  contract,
  agent,
  admin
};

const StoreContext = React.createContext<RootStore>(store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);

export { auth, supplier, contract, agent, admin };
